import {
  BasicInfoBeneficiary,
  SupplierEquipmentForm,
} from './components';

export const stepsEquipmentSupplier = [
  {
    name: 'SUPPLIEREQUIPMENTFORM',
    label: 'Εξοπλισμός',
    Component: SupplierEquipmentForm,
    id: 0,
  },
  {
    name: 'BASICFORM',
    label: 'Στοιχεία Ωφελούμενου',
    Component: BasicInfoBeneficiary,
    id: 1,
  },
];